// @flow @jsx h

import ScrollSlideshow from '../ScrollSlideshow'
import { h } from 'preact'
import Background from './Background'
import Section from './Section'
import style from './index.css'

import type { Slide } from './types'

type Props = {
  value: {
    slides: Slide[]
  },
  mediaBaseUrl: string,
  viewport: any
}

function Slideshow (props: Props) {
  const { mediaBaseUrl, viewport } = props
  const { slides } = props.value

  const backgrounds = slides.map((slide, idx) => {
    return (
      <Background key={String(idx)} {...slide} mediaBaseUrl={mediaBaseUrl} />
    )
  })

  const sections = slides.map((slide, idx) => {
    return <Section key={String(idx)} {...slide} />
  })

  return (
    <ScrollSlideshow
      className={style.slideshow}
      backgrounds={backgrounds}
      sections={sections}
      viewport={viewport}
    />
  )
}

export default Slideshow



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/Slideshow/index.js